import { NotificationChannel } from "@sinch/components/application/Messages/useMessageChannels";
import { MessageFormFields } from "./formSchema";

/**
 * Resolves the message body to send for the selected channels.
 *
 * A single message is sent per submission, so the channel-specific field is
 * picked by priority: email, then SMS, then push.
 */
export const resolveChannelMessage = (
  channels: NotificationChannel[],
  { message, textMessage, pushMessage }: Pick<MessageFormFields, "message" | "textMessage" | "pushMessage">
): string => {
  if (channels.includes(NotificationChannel.Email)) {
    return message;
  }
  if (channels.includes(NotificationChannel.Sms)) {
    return textMessage;
  }
  if (channels.includes(NotificationChannel.Push)) {
    return pushMessage;
  }
  return "";
};
